/**
 * AuthSync
 *
 * Renders nothing but registers the Clerk `getToken` function with the
 * authGetter module so that the Axios interceptor in apiClient.ts can
 * obtain a fresh JWT without importing @clerk/clerk-js directly.
 *
 * Must be rendered inside <ClerkProvider>.
 */

import { useEffect } from 'react';
import { useAuth } from '../services/clerkReact';
import { registerTokenGetter } from '../services/authGetter';
import { clearCachedOrganization } from '../services/apiClient';

export default function AuthSync() {
  const { getToken, isSignedIn } = useAuth();

  useEffect(() => {
    registerTokenGetter(() => getToken());
  }, [getToken]);

  useEffect(() => {
    if (!isSignedIn) {
      clearCachedOrganization();
    }
  }, [isSignedIn]);

  return null;
}
